import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import QueryKeys from '@src/constants/queryKeys';
import useEventMutations from '@src/hooks/api/mutations/useEventMutations';
import { useQueryClient } from '@tanstack/react-query';
import { UUID } from 'crypto';
import { Dispatch, SetStateAction } from 'react';

interface EventDeleteDialogProps {
  eventId: UUID;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
}

export default function EventDeleteDialog({
  eventId,
  setOpen,
  setAnchorEl,
}: EventDeleteDialogProps) {
  const { deleteCalendarEvent } = useEventMutations(eventId);

  const queryClient = useQueryClient();

  const handleSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: [QueryKeys.events],
    });
    setAnchorEl(null);
    setOpen(false);
  };

  const handleDelete = () =>
    deleteCalendarEvent.mutate(
      {},
      {
        onSuccess: () => handleSuccess(),
        onError: (error) => {
          console.error('Error deleting event:', error);
        },
      },
    );
  return (
    <Dialog open>
      <DialogTitle>Delete Site Event</DialogTitle>
      <DialogContent>
        This will remove Site Event permanently. You cannot undo this action
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} color='inherit' disableElevation>
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color='error'
          variant='outlined'
          disableElevation
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
